import i18n from "@/i18n";

export function calendarConfigs() {
    return {
        dayNames: [
            i18n.t("posts.monday"),
            i18n.t("posts.tuesday"),
            i18n.t("posts.wednesday"),
            i18n.t("posts.thursday"),
            i18n.t("posts.friday"),
            i18n.t("posts.saturday"),
            i18n.t("posts.sunday")
        ],
        monthNames: [
            i18n.t("common.january"),
            i18n.t("common.february"),
            i18n.t("common.march"),
            i18n.t("common.april"),
            i18n.t("common.may"),
            i18n.t("common.june"),
            i18n.t("common.july"),
            i18n.t("common.august"),
            i18n.t("common.september"),
            i18n.t("common.october"),
            i18n.t("common.november"),
            i18n.t("common.december")
        ]
    };
}
